<template>
  <div class="empty-box">
    <div>
      <div class="text">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .empty-box {
    text-align: center;
    width: 100%;
    padding: 80px 30px;
    box-sizing: border-box;
    .text {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 30px;
    }
  }
</style>
